import { gql } from '@apollo/client';

export const AvatarFragment = gql`
  fragment Avatar on Avatar {
    color
    initials
  }
`;
